export default "__VITE_ASSET__D0eDt$6A__"